import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'
import WriteArticle from '../views/writeArticle/index.vue'
import Schedule from '../views/schedule/index.vue'
import MusicControl from '../views/music/index.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/write', name: 'WriteArticle', component: WriteArticle },
  { path: '/schedule', name: 'Schedule', component: Schedule },
  { path: '/music', name: 'MusicControl', component: MusicControl }
]

const router = new VueRouter({
  routes
})

export default router
